import { AssessmentQuestion } from 'fitbeat.models';
import React from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { reduxForm } from 'redux-form';
import { BodyscaleAssessmentQuestions } from './bodyscale-assessment-questions';

interface IProps {
    questionsAndAnswers: AssessmentQuestion[];
    currentQuestion: AssessmentQuestion;
    currentQuestionAnswers: AssessmentQuestion[];
    metrics: any;
    isSaving: boolean;
    t: (key: string) => string;
    setAnswer(): void;
    getNextQuestion(answer: string): void;
    getPreviousQuestion(answer: string): void;
}

class BodyscaleAssessmentComponent extends React.PureComponent<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        const {
            t,
            questionsAndAnswers,
            currentQuestion,
            currentQuestionAnswers,
            metrics,
            isSaving,
            setAnswer,
            getNextQuestion,
            getPreviousQuestion,
        } = this.props;

        return (
            <View style={styles.container}>
                <BodyscaleAssessmentQuestions
                    metrics={metrics}
                    questionsAndAnswers={questionsAndAnswers}
                    currentQuestion={currentQuestion} answers={currentQuestionAnswers}
                    onAnswerChange={setAnswer}
                    onNext={getNextQuestion}
                    onPrevious={getPreviousQuestion}
                    isSaving={isSaving} />
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});

export const BodyscaleAssessment = reduxForm({ form: 'bodyscaleAssessment' })(
    translate(['bodyscan'], { wait: true })(BodyscaleAssessmentComponent));
